import { Injectable } from '@angular/core';

@Injectable()
export class ErrorReportingService {
  // See: https://www.ibm.com/docs/en/instana-observability/current?topic=websites-javascript-agent-api#manual-error-reporting

  reportToInstana(error: any, metaValues?: Record<string, string>): void {
    // report to Instana, if available
    const _window = window as {
      ineum?: (any, reportableError, metaValues?) => void;
    };

    if (_window && _window.ineum) {
      if (metaValues) {
        _window.ineum('reportError', error, {
          meta: metaValues,
        });
      } else {
        _window.ineum('reportError', error);
      }
    }
  }
}
